/* External dependencies */
import update from 'react-addons-update';

/* Local dependencies */
import { PasswordLogInActions, PasswordLogInActionTypes } from './actions';

export interface LogInState {
  passwordValue: string;
  passwordError: null | string;
  passwordIsValid: boolean;
}

export const initialState: LogInState = {
  passwordValue: '',
  passwordError: null,
  passwordIsValid: false,
};

export function logInReducer(state: LogInState = initialState, action: PasswordLogInActions): LogInState {
  switch (action.type) {
    case PasswordLogInActionTypes.INPUT_PASSWORD:
      return update(state, {
        passwordValue: { $set: action.payload },
        passwordError: { $set: initialState.passwordError },
      });

    case PasswordLogInActionTypes.LOGIN_PASSWORD_SUBMIT:
      if (action.passwordValue.length !== 0) {
        return update(state, {
          passwordIsValid: { $set: true },
          passwordError: { $set: null },
        });
      }
      return update(state, {
        passwordError: { $set: action.errorMessage },
        passwordIsValid: { $set: false },
      });

    case PasswordLogInActionTypes.RESET_STATE:
      return { ...initialState };

    default:
      return state;
  }
}
